import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public navbarOpen: boolean;
  constructor() { }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  closePopup() {
    this.navbarOpen = false;
  }
  ngOnInit(): void {
  }

}
